document.addEventListener('DOMContentLoaded', () => {
  const popupTriggers = document.querySelectorAll('.custom-popup-trigger');
  const popupOverlay = document.querySelector('.custom-popup-overlay');
  
  if (!popupTriggers.length || !popupOverlay) return;
  
  // Hide triggers for popups with no content
  popupTriggers.forEach(trigger => {
    const popupId = trigger.getAttribute('data-trigger');
    if (!popupId) return;
    
    // Extract the popup ID from the data-trigger attribute
    const idMatch = popupId.match(/custom-popup-(.+)/);
    if (!idMatch || !idMatch[1]) return;
    
    const extractedId = idMatch[1];
    
    // Check if the popup has content
    if (window.customPopupHasContent && window.customPopupHasContent[extractedId] === false) {
      trigger.style.display = 'none';
      return;
    }
    
    const popup = document.querySelector(`#${popupId}`);
    
    if (!popup) return;
    
    const closeButton = popup.querySelector('.custom-popup-title');
    const closeElements = [closeButton, popupOverlay];
    
    trigger.addEventListener('click', () => {
      popup.classList.toggle('activePopup');
      popupOverlay.classList.toggle('activePopup');
    });
    
    closeElements.forEach((element) => {
      element.addEventListener('click', () => {
        popup.classList.remove('activePopup');
        popupOverlay.classList.remove('activePopup');
      });
    });
  });
}); 